import { ApiUrl } from "@/api/api-url";
import HttpClient from "@/api/HttpClient";
import { getCurrentDate } from "@/util/date-util";

export interface ConversionTrendResultJson {
  conversion_id: number;
  conversion_name: string;
  data: {
    date: string;
    count: number;
  }[];
}

export interface ConversionTrendApiResponse {
  id: string;
  status: ConversionTrendStatus;
  result?: ConversionTrendResultJson[];
}

export enum ConversionTrendStatus {
  NOT_STARTED = "NOT_STARTED",
  SUCCEEDED = "SUCCEEDED",
  RUNNING = "RUNNING",
  FAILED = "FAILED"
}

export default class ConversionTrend {
  constructor(private readonly httpClient: HttpClient) {}

  public createNew(): Promise<ConversionTrendApiResponse> {
    const url: string = ApiUrl.CV_TREND;
    const params = {
      app_user_timezone: getCurrentDate().getTimezoneOffset()
    };

    return this.httpClient.post<ConversionTrendApiResponse>(url, params);
  }

  public getResult(id: string): Promise<ConversionTrendApiResponse> {
    const url: string = `${ApiUrl.CV_TREND}${id}/`;

    return this.httpClient.get<ConversionTrendApiResponse>(url);
  }
}
